import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { SiteFooter } from './SiteFooter';
export function CTA() {
  return <>
      <Section className="bg-brand-navy text-white relative overflow-hidden" data-id="element-617">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-618">
          <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] bg-brand-teal/20 rounded-full blur-[120px]" data-id="element-619" />
          <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] bg-brand-coral/20 rounded-full blur-[120px]" data-id="element-620" />
        </div>

        <div className="relative z-10 text-center max-w-4xl mx-auto" data-id="element-621">
          <FadeIn data-id="element-622">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-balance text-white" data-id="element-623">
              Your next offsite should do more than fill a room.
            </h2>
            <p className="text-xl text-slate-300 mb-10 text-balance max-w-2xl mx-auto" data-id="element-624">
              Use Offsite+ to design, run, and measure a better group experience
              before, during, and after the event.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-625">
              <Button variant="accent" size="lg" href="/designer" data-id="element-626">
                Design Your Free Offsite
              </Button>
              <Button variant="outline" size="lg" className="border-white/20 text-white hover:bg-white/10 hover:border-white/40" data-id="element-627">
                Book a Partner Demo
              </Button>
            </div>
          </FadeIn>
        </div>
      </Section>

      <SiteFooter data-id="element-628" />
    </>;
}